/* global axios */
import ApiClient from '../ApiClient';

class NexceoSettingsAPI extends ApiClient {
  constructor() {
    super('nexceo/settings', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.put(this.url, { settings: payload });
  }

  /**
   * Test a notification channel.
   * For chatwoot_whatsapp, pass either project_team_member_id or test_phone.
   */
  testNotification(channel = 'private_note', options = {}) {
    return axios.post(`${this.url}/test_notification`, { channel, ...options });
  }

  /** Fetch active project team members that have a WhatsApp number configured. */
  whatsappTestRecipients() {
    return axios.get(`${this.url}/whatsapp_test_recipients`);
  }

  /** Check if follow-up WhatsApp templates are synced on the configured inbox. */
  checkFollowupTemplates() {
    return axios.get(`${this.url}/check_followup_templates`);
  }

  /** Check if all 4 meeting confirmation templates are synced on WhatsApp inboxes. */
  checkMeetingTemplates() {
    return axios.get(`${this.url}/check_meeting_templates`);
  }
}

export default new NexceoSettingsAPI();
